import * as React from 'react';
import styled from 'styled-components';
import FirebaseContext from '../../contexts/FirebaseContext';
import MenuLink from '../MenuLink';
import sunIconUrl from './icons/sun.svg';
import MenuDropdown from '../MenuDropdown';
import { auth } from '../../firebase';
import { pages } from '../../../config';
import { ActionMenuItem } from '../ActionMenu';
import Button from '../Button';

const userMenuItems: (uid: string) => ActionMenuItem[] = (uid) => [
  {
    content: 'Your Library',
    to: pages.memberLibrary,
  },
  {
    content: 'Your Profile',
    to: `/member/${uid}`,
  },
  {
    content: 'Create Playlist',
    to: pages.createPlaylist,
  },
  {
    content: 'divider-1',
    isDivider: true,
  },
  {
    content: 'Help',
    to: pages.contact,
  },
  {
    content: 'Settings',
    to: pages.memberProfileSettings,
  },
  {
    content: 'divider-2',
    isDivider: true,
  },
  {
    content: 'Sign out',
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();
      auth.signOut();
    },
  },
];

const Wrapper = styled.div`
  width: 100%;

  img {
    display: none;
  }

  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    gap: 20px;
    width: auto;

    img {
      display: block;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      object-fit: cover;
    }
  }
`;

const MenuTitle = styled.span`
  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    gap: 20px;

    strong {
      font-weight: inherit;
    }
  }
`;

const UserMenuDropdown = styled(MenuDropdown)`
  button {
    width: 100%;

    svg {
      transform: rotate(-90deg);
    }
  }

  &__menu {
    position: absolute;
    min-width: 240px;
  }

  @media (min-width: 992px) {
    button {
      svg {
        display: none;
      }
    }

    &__menu {
      position: static;
    }
  }
`;

const SignInButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;

  @media (min-width: 992px) {
    gap: 20px;
    justify-content: flex-start;
  }
`;

const SignInButtonWrapper = styled.div`
  a {
    font-size: 15px;
    font-weight: 600;
  }
`;

export default function UserMenu() {
  const { initializing, user, loadingMember, member } = React.useContext(FirebaseContext);

  const firstName = React.useMemo(() => {
    const fullName = member?.name || user?.displayName;

    if (fullName) {
      const [fName] = fullName.split(' ');
      return fName;
    }

    if (user?.email) {
      const [fName] = user.email.split('@');
      return fName;
    }

    return 'Member';
  }, [member, user]);

  if (initializing || loadingMember) {
    return null;
  }

  return (
    <Wrapper>
      {user ? (
        <UserMenuDropdown
          title={
            <MenuTitle>
              <img
                src={member?.photoURL || user?.photoURL || sunIconUrl}
                alt="member avatar"
                referrerPolicy="no-referrer"
              />
              <strong>{firstName}</strong>
            </MenuTitle>
          }
          align="start"
          items={userMenuItems(user.uid)}
        />
      ) : (
        <SignInButtonsWrapper>
          <MenuLink to={pages.signIn}>Sign in</MenuLink>
          <SignInButtonWrapper>
            <Button as={MenuLink} to={pages.becomeAMember} invert small>
              Sign up
            </Button>
          </SignInButtonWrapper>
        </SignInButtonsWrapper>
      )}
    </Wrapper>
  );
}
